// This file is auto-generated by scripts/generate-models.ts
// Do not edit manually - run 'npm run generate-models' to update

import type { Model } from "../types.ts";

export const GOOGLE_MODELS = {
	"gemini-2.0-flash": {
		id: "gemini-2.0-flash",
		name: "Gemini 2.0 Flash",
		api: "google-generative-ai",
		provider: "google",
		baseUrl: "https://generativelanguage.googleapis.com/v1beta",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.1,
			output: 0.4,
			cacheRead: 0.025,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 8192,
	} satisfies Model<"google-generative-ai">,
	"gemini-2.0-flash-lite": {
		id: "gemini-2.0-flash-lite",
		name: "Gemini 2.0 Flash-Lite",
		api: "google-generative-ai",
		provider: "google",
		baseUrl: "https://generativelanguage.googleapis.com/v1beta",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.075,
			output: 0.3,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 8192,
	} satisfies Model<"google-generative-ai">,
	"gemini-2.5-flash": {
		id: "gemini-2.5-flash",
		name: "Gemini 2.5 Flash",
		api: "google-generative-ai",
		provider: "google",
		baseUrl: "https://generativelanguage.googleapis.com/v1beta",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.3,
			output: 2.5,
			cacheRead: 0.03,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 65536,
	} satisfies Model<"google-generative-ai">,
	"gemini-2.5-flash-lite": {
		id: "gemini-2.5-flash-lite",
		name: "Gemini 2.5 Flash-Lite",
		api: "google-generative-ai",
		provider: "google",
		baseUrl: "https://generativelanguage.googleapis.com/v1beta",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.1,
			output: 0.4,
			cacheRead: 0.01,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 65536,
	} satisfies Model<"google-generative-ai">,
	"gemini-2.5-pro": {
		id: "gemini-2.5-pro",
		name: "Gemini 2.5 Pro",
		api: "google-generative-ai",
		provider: "google",
		baseUrl: "https://generativelanguage.googleapis.com/v1beta",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1.25,
			output: 10,
			cacheRead: 0.125,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 65536,
	} satisfies Model<"google-generative-ai">,
	"gemini-3-flash-preview": {
		id: "gemini-3-flash-preview",
		name: "Gemini 3 Flash Preview",
		api: "google-generative-ai",
		provider: "google",
		baseUrl: "https://generativelanguage.googleapis.com/v1beta",
		reasoning: true,
		thinkingLevelMap: {"off":null},
		input: ["text", "image"],
		cost: {
			input: 0.5,
			output: 3,
			cacheRead: 0.05,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 65536,
	} satisfies Model<"google-generative-ai">,
	"gemini-3-pro-preview": {
		id: "gemini-3-pro-preview",
		name: "Gemini 3 Pro Preview",
		api: "google-generative-ai",
		provider: "google",
		baseUrl: "https://generativelanguage.googleapis.com/v1beta",
		reasoning: true,
		thinkingLevelMap: {"off":null,"minimal":null,"low":"LOW","medium":null,"high":"HIGH"},
		input: ["text", "image"],
		cost: {
			input: 2,
			output: 12,
			cacheRead: 0.2,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 65536,
	} satisfies Model<"google-generative-ai">,
	"gemini-3.1-flash-lite": {
		id: "gemini-3.1-flash-lite",
		name: "Gemini 3.1 Flash Lite",
		api: "google-generative-ai",
		provider: "google",
		baseUrl: "https://generativelanguage.googleapis.com/v1beta",
		reasoning: true,
		thinkingLevelMap: {"off":null},
		input: ["text", "image"],
		cost: {
			input: 0.25,
			output: 1.5,
			cacheRead: 0.025,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 65536,
	} satisfies Model<"google-generative-ai">,
	"gemini-3.1-flash-lite-preview": {
		id: "gemini-3.1-flash-lite-preview",
		name: "Gemini 3.1 Flash Lite Preview",
		api: "google-generative-ai",
		provider: "google",
		baseUrl: "https://generativelanguage.googleapis.com/v1beta",
		reasoning: true,
		thinkingLevelMap: {"off":null},
		input: ["text", "image"],
		cost: {
			input: 0.25,
			output: 1.5,
			cacheRead: 0.025,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 65536,
	} satisfies Model<"google-generative-ai">,
	"gemini-3.1-pro-preview": {
		id: "gemini-3.1-pro-preview",
		name: "Gemini 3.1 Pro Preview",
		api: "google-generative-ai",
		provider: "google",
		baseUrl: "https://generativelanguage.googleapis.com/v1beta",
		reasoning: true,
		thinkingLevelMap: {"off":null,"minimal":null,"low":"LOW","medium":null,"high":"HIGH"},
		input: ["text", "image"],
		cost: {
			input: 2,
			output: 12,
			cacheRead: 0.2,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 65536,
	} satisfies Model<"google-generative-ai">,
	"gemini-3.1-pro-preview-customtools": {
		id: "gemini-3.1-pro-preview-customtools",
		name: "Gemini 3.1 Pro Preview Custom Tools",
		api: "google-generative-ai",
		provider: "google",
		baseUrl: "https://generativelanguage.googleapis.com/v1beta",
		reasoning: true,
		thinkingLevelMap: {"off":null,"minimal":null,"low":"LOW","medium":null,"high":"HIGH"},
		input: ["text", "image"],
		cost: {
			input: 2,
			output: 12,
			cacheRead: 0.2,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 65536,
	} satisfies Model<"google-generative-ai">,
	"gemini-3.5-flash": {
		id: "gemini-3.5-flash",
		name: "Gemini 3.5 Flash",
		api: "google-generative-ai",
		provider: "google",
		baseUrl: "https://generativelanguage.googleapis.com/v1beta",
		reasoning: true,
		thinkingLevelMap: {"off":null},
		input: ["text", "image"],
		cost: {
			input: 1.5,
			output: 9,
			cacheRead: 0.15,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 65536,
	} satisfies Model<"google-generative-ai">,
	"gemini-flash-latest": {
		id: "gemini-flash-latest",
		name: "Gemini Flash Latest",
		api: "google-generative-ai",
		provider: "google",
		baseUrl: "https://generativelanguage.googleapis.com/v1beta",
		reasoning: true,
		thinkingLevelMap: {"off":null},
		input: ["text", "image"],
		cost: {
			input: 1.5,
			output: 9,
			cacheRead: 0.15,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 65536,
	} satisfies Model<"google-generative-ai">,
	"gemini-flash-lite-latest": {
		id: "gemini-flash-lite-latest",
		name: "Gemini Flash-Lite Latest",
		api: "google-generative-ai",
		provider: "google",
		baseUrl: "https://generativelanguage.googleapis.com/v1beta",
		reasoning: true,
		thinkingLevelMap: {"off":null},
		input: ["text", "image"],
		cost: {
			input: 0.25,
			output: 1.5,
			cacheRead: 0.025,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 65536,
	} satisfies Model<"google-generative-ai">,
	"gemma-4-26b-a4b-it": {
		id: "gemma-4-26b-a4b-it",
		name: "Gemma 4 26B A4B IT",
		api: "google-generative-ai",
		provider: "google",
		baseUrl: "https://generativelanguage.googleapis.com/v1beta",
		reasoning: true,
		thinkingLevelMap: {"off":null,"minimal":"MINIMAL","low":null,"medium":null,"high":"HIGH"},
		input: ["text", "image"],
		cost: {
			input: 0,
			output: 0,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 32768,
	} satisfies Model<"google-generative-ai">,
	"gemma-4-31b-it": {
		id: "gemma-4-31b-it",
		name: "Gemma 4 31B IT",
		api: "google-generative-ai",
		provider: "google",
		baseUrl: "https://generativelanguage.googleapis.com/v1beta",
		reasoning: true,
		thinkingLevelMap: {"off":null,"minimal":"MINIMAL","low":null,"medium":null,"high":"HIGH"},
		input: ["text", "image"],
		cost: {
			input: 0,
			output: 0,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 32768,
	} satisfies Model<"google-generative-ai">,
} as const;
